export default "__VITE_ASSET__BEWcOio$__"